<h2 mat-dialog-title>{{ title }}</h2>

<div mat-dialog-content>
    <form [formGroup]="categoryForm" class="form row">
        <div class="col-12 col-md-6">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput type="text" formControlName="name" required />
            </mat-form-field>
        </div>

        <div class="col-12 col-md-3">
            <mat-form-field>
                <mat-label>Kind</mat-label>
                <mat-select formControlName="kind">
                    <mat-option value="work">Work</mat-option>
                    <mat-option value="pre_work">Pre-work</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-3">
            <mat-form-field>
                <mat-label>Order</mat-label>
                <input matInput type="number" formControlName="sort_order" />
            </mat-form-field>
        </div>

        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="fw-semibold">Settings</span>
                <button mat-stroked-button type="button" (click)="addSettingRow()">Add Setting</button>
            </div>
            <p class="text-muted small mb-2">
                Key/value pairs consumed by the form builder. Values may be JSON
                (e.g. <code>["door_type"]</code>) or plain text.
            </p>

            <div formArrayName="settings">
                @for (row of settingsRows.controls; track row; let i = $index) {
                    <div class="row" [formGroupName]="i">
                        <div class="col-5">
                            <mat-form-field class="w-100">
                                <mat-label>Key</mat-label>
                                <input matInput type="text" formControlName="key" />
                            </mat-form-field>
                        </div>
                        <div class="col-5">
                            <mat-form-field class="w-100">
                                <mat-label>Value</mat-label>
                                <input matInput type="text" formControlName="value" />
                            </mat-form-field>
                        </div>
                        <div class="col-2 d-flex align-items-center">
                            <button mat-icon-button type="button" (click)="removeSettingRow(i)" aria-label="Remove setting">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    </form>
</div>

<div mat-dialog-actions>
    <button mat-stroked-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="primary" (click)="submitForm()">Save</button>
</div>
